import { HttpClient } from '@angular/common/http';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, Observer, Subscription } from 'rxjs';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FilterTermPipe } from '../../../pipes/filter-term.pipe';
import { arrayBuffer } from 'stream/consumers';
import { TagInputAccessor } from 'ngx-chips/core/accessor';

declare var $: any;

export const CHECKLIST_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckListComponent),
  multi: true
};

@Component({
    selector: '[checkListInput]',
  templateUrl: 'check-list.component.html',
  providers: [CHECKLIST_VALUE_ACCESSOR]
})
export class CheckListComponent implements ControlValueAccessor, OnInit {
  @Input() labelInput: string;
  @Input() checkListOptions: any;
  @Input() legendGroups: any; // esempio estrazione-dati-campi.ts
  @Input() control: AbstractControl;
  @Input() divClass: string;
  @Input() idInput: string;
  @Input() submitPending: boolean;
  @Input() isCD: boolean;
  @Input() sottoGruppi: any;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  isFs: boolean = PropertiesSettings.ID_TENANTS_FS();
  private _value: any;
  private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };
  private optionCallback: any;
  private randomValueString: string;
  public enableObservable: Observable<boolean>;
  private subscription: Subscription = null;
  private enableObserver: Observer<boolean>;

  metadatiLabel : string = 'Tutti';
  maxItemsMetadati : number = 10;
  metadatiSelezionati : string[] = [];

  constructor(private httpService: HttpClient, private filterTermPipe: FilterTermPipe) {
    this.randomValueString = '' + Math.round(Math.random() * 100000);
  }

  private createServiceSubscription() {
    this.enableObservable = new Observable<boolean>(observer => {
      this.enableObserver = observer;
    if ( this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }

  }

  ngOnChanges(): void{
    this.isMaxItemsSelected('metadati');
  }

  isChecked(elementId: string) {
    let result;
    if (this._value) {
      result = $.grep(this._value, function(e: any) { return e ? e.id === elementId : null; });
    }
    if (result && result.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  onChange(optionId: string, event: any): any {
    this.optionCallback = this._value;
      if (event.target.checked) {
        let newElement: any = this.checkListOptions.filter(item => item.id === optionId);
        this.onMetadataSelected(newElement,event.target.checked);
        this.optionCallback.push(newElement[0]);
      } else {
        let newElement: any = this.checkListOptions.filter(item => item.id === optionId);
        this.onMetadataSelected(newElement,event.target.checked);
        this.optionCallback = this.optionCallback.filter(item => item.id !== optionId);
      }
      this._value = this.optionCallback;
      this.onChangeCallback(this.optionCallback);
  }

  private onMetadataSelected(newElement: any,check: boolean) {
    if (newElement[0].idGruppo === 'metadati') {
      if(check){
        if(this.metadatiSelezionati.findIndex(elem => elem === newElement[0].id) === -1){
          this.metadatiSelezionati.push(newElement[0].id);
        }
      } else {
        this.metadatiSelezionati.splice(this.metadatiSelezionati.findIndex(elem => elem === newElement[0].id), 1);
      }
    }
    if (this.metadatiLabel !== 'Tutti') {
      this.metadatiLabel = this.metadatiSelezionati.length + " di " + this.maxItemsMetadati + " elementi selezionati";
    }
  }

  onCheckAllItems(event: any, groupId: any) {
    let group;
    group = this.filterTermPipe.transform(this.checkListOptions, groupId, 'idGruppo');
    for (let item of group) {
      this.onChange(item.id, event);
    }
  }

  onCheckMaxItems(event: any,groupId: any){
    let group;
    group = this.filterTermPipe.transform(this.checkListOptions, groupId, 'idGruppo');
    if(event.target.checked){
      group = group.filter(item1 => !this.metadatiSelezionati.some(item2 => item2 === item1.id)).slice(0,this.maxItemsMetadati - this.metadatiSelezionati.length)
    }
    for (let item of group) {
        this.onChange(item.id, event);
    }
  }


  isMaxItemsSelected(groupId : string){
    if( this.checkListOptions.filter(item => item.idGruppo === groupId).length > this.maxItemsMetadati){
      this.metadatiLabel = this.metadatiSelezionati.length + " di " + this.maxItemsMetadati + " elementi selezionati";
    }
  }

  onDisabledUnchecked(elementId: string, idGruppo: string){
    if(idGruppo === 'metadati'){
      return this.metadatiSelezionati.length >= this.maxItemsMetadati && this.metadatiSelezionati.findIndex( elem => elem === elementId) === -1;
    } else  {
      return false
    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
}
